// extracted by mini-css-extract-plugin
export default {"container":"TopService_container__8wm2v","topservice_heading":"TopService_topservice_heading__y4-EO","pointCard":"TopService_pointCard__GhJLH"};